export default "__VITE_ASSET__CMZqq4B$__"